import { Link } from 'react-router-dom';
import ResourceCard from '@/components/feature/ResourceCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { getLatestResources } from '@/lib/catalog';

export default function LatestResources() {
  const resources = getLatestResources(6);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14">
        <SectionHeading
          title="最新上线资源"
          description="按发布时间倒序，第一时间发现新鲜内容。"
          icon="ri-time-line"
          action={
            <Link
              to="/search"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {resources.map((resource) => (
            <ResourceCard key={resource.id} resource={resource} />
          ))}
        </div>
      </div>
    </section>
  );
}